<div
  class="relative flex h-full min-h-screen w-full select-none flex-col items-center justify-center overflow-auto overflow-x-hidden bg-black"
>
  <div
    [ngClass]="secondLanding ? 'pt-[14.2rem] lg:pt-[6.4rem]' : 'pt-[3.05rem] lg:pt-[2rem]'"
    class="relative flex h-full w-full max-w-[117.2rem] flex-col justify-start bg-black lg:max-w-[60rem] lg:px-[1.6rem]"
  >
    <ng-container *ngTemplateOutlet="firstBlock" />
    <ng-container *ngTemplateOutlet="secondBlock" />
    @if (isLg() && !secondLanding) {
      <img
        loading="lazy"
        fetchpriority="low"
        class="absolute right-[0] top-0 z-[1] w-[34.8rem]"
        src="/assets/images/landing/firstBlock/phoneMob.png"
      />
    }
  </div>
  <div class="relative flex w-full flex-col items-center justify-center">
    <ng-container *ngTemplateOutlet="thirdBlock" />
    <div class="flex w-full max-w-[117.2rem] justify-start lg:max-w-[60rem]">
      <ng-container *ngTemplateOutlet="footer" />
    </div>
    <div class="flex hidden flex-col text-left lg:flex lg:px-[1.6rem] lg:pb-[2rem]">
      <div class="text-[1.4rem] font-400 leading-[2.2rem] text-[#A4AECB] lg:text-[1rem] lg:leading-normal">
        &copy; 2018 &#8211; {{ currentYear }} CSFail
      </div>

      <div
        class="w-[35rem] text-[1.2rem] font-325 leading-[2rem] text-[#7F8BAD] lg:w-full lg:text-[1rem] lg:leading-normal"
      >
        @if (isRuLanguage) {
          AG AUTOMOTIVE LOGISTICS AND MANAGEMENT PTE. LTD.: Company number 202350466K, 68 CIRCULAR ROAD #02-01 SINGAPORE
          (049422)
        } @else {
          ITSFAIL LTD: Company number 13246765, 16 John Nicholas Crescent, Ellesmere Port, Cheshire, United Kingdom,
          CH65 2DL
        }
      </div>
    </div>
  </div>
  @if (!isLg() && !secondLanding) {
    <img
      loading="lazy"
      fetchpriority="low"
      class="absolute left-1/2 top-0 top-[-6.5rem] z-[1] ml-[32rem] w-[111.6rem] -translate-x-1/2"
      src="/assets/images/landing/firstBlock/men.png"
    />
  }
  @if (secondLanding) {
    <img
      loading="lazy"
      fetchpriority="low"
      class="absolute left-1/2 top-0 top-[0rem] z-[1] ml-[30rem] w-[135rem] -translate-x-1/2 lg:ml-[6rem] lg:max-w-[39.1rem]"
      src="/assets/images/landing2/firstBlock/men.webp"
    />
  }
  <img
    loading="lazy"
    fetchpriority="low"
    class="absolute right-0 top-0 z-[0] h-screen w-full"
    [src]="
      isLg() ? '/assets/images/landing/firstBlock/mobShadow.webp' : '/assets/images/landing/firstBlock/shadow.webp'
    "
  />
</div>

<ng-template #firstBlock>
  <div
    [ngClass]="secondLanding ? 'space-y-[5rem] lg:space-y-0' : 'space-y-[13rem] lg:space-y-[3.4rem]'"
    class="flex w-full flex-col items-start lg:items-center"
  >
    <div class="z-[11] flex w-full max-w-[1172px] flex-col space-y-[8rem] pl-[2.7rem] lg:max-w-[60rem] lg:pl-[0.5rem]">
      <div class="flex flex-col space-y-[6.3rem] lg:space-y-[1.8rem]">
        @if (!secondLanding) {
          <div class="flex space-x-[0.44rem]">
            <div class="z-[1] flex items-center space-x-[0.44rem]">
              <img class="w-[4.915rem] lg:w-[3.17rem]" src="/assets/images/logo/logo.svg" />
              <img class="w-[10.931rem] lg:w-[7.06rem]" src="/assets/images/logo/text.svg" />
            </div>
          </div>
        }
        <div class="flex flex-col space-y-[8rem] lg:space-y-[2.9rem]">
          <div class="flex flex-col space-y-[2.4rem] lg:space-y-[0.7rem]">
            <img
              loading="lazy"
              fetchpriority="low"
              class="w-[15.7rem] lg:w-[8.6rem]"
              src="/assets/images/landing/firstBlock/icons/stars.svg"
            />
            <div class="flex flex-col space-y-[1rem] lg:flex-wrap">
              <div class="flex flex-col">
                <span
                  i18n="@@landing.ak47"
                  class="max-w-[73.6rem] text-[6rem] font-500 uppercase leading-[6.6rem] text-white lg:max-w-[18.7rem] lg:text-[1.6rem] lg:leading-[2.4rem]"
                  >Поднял AK-47 Императрицу</span
                >
                <div class="lg:flex lg:flex-col lg:items-start lg:space-y-[0.6rem]">
                  <span
                    class="text-[6rem] font-500 uppercase leading-[6.6rem] text-white lg:max-w-[19.7rem] lg:text-[1.6rem] lg:leading-[2.4rem]"
                  >
                    <span class="mr-[0.5rem] lg:mr-[0.35rem]" i18n="@@landing.oncsfail">на</span>CSFAIL
                  </span>
                  @if (isLg()) {
                    <div class="white-promo-border l relative flex w-fit items-center justify-center">
                      <span
                        i18n="@@landing.bonus"
                        class="whitespace-nowrap text-[2.8rem] font-500 uppercase leading-[2.8rem] text-black lg:text-[1rem] lg:leading-[1rem]"
                        >+10% при регистрации!</span
                      >
                    </div>
                  }
                </div>
              </div>
              @if (!isLg()) {
                <div class="white-promo-border relative ml-[0.5rem] flex w-fit items-center justify-center">
                  <span
                    i18n="@@landing.bonus"
                    class="whitespace-nowrap text-[2.8rem] font-500 uppercase leading-[2.8rem] text-black lg:text-[1rem] lg:leading-[1rem]"
                    >+10% при регистрации!</span
                  >
                </div>
              }
            </div>
          </div>
          <div class="flex space-x-[1.2rem] lg:space-x-[0.6rem]">
            <ng-container *ngTemplateOutlet="loginButtons"></ng-container>
            <button
              (click)="copyCode('WELCOME10')"
              class="group relative flex items-center justify-between space-x-[1.6rem] rounded-[1.8rem] bg-[rgba(163,103,215,0.38)] px-[1.6rem] custom-transition-all hover:bg-[rgba(163,103,215,0.48)] lg:space-x-[0.9rem] lg:rounded-[1.2rem] lg:px-[1rem] lg:backdrop-blur-[0.2rem]"
            >
              <div
                class="absolute left-0 top-0 h-full w-full rounded-[1.8rem] border border-dashed border-[#946AC3] opacity-0 custom-transition-all group-hover:opacity-100 lg:rounded-[1.2rem]"
              ></div>
              <div class="!ml-0 flex w-[11.8rem] flex-col items-start lg:w-[7.9rem]">
                <span
                  class="text-[1.2rem] font-400 leading-[1.6rem] text-white lg:text-[1rem]"
                  i18n="@@landing.btn_code"
                  >+10% с кодом</span
                >
                <span
                  class="text-[1.6rem] font-450 uppercase leading-[2rem] text-[#FF96D0] lg:text-[1.1rem] lg:leading-[1.4rem]"
                  >“WELCOME10”</span
                >
              </div>
              <button>
                <img
                  loading="lazy"
                  fetchpriority="low"
                  class="h-[2.2rem] w-[2.2rem] lg:h-[1.6rem] lg:w-[1.6rem]"
                  src="/assets/images/landing/firstBlock/icons/copyIcon.svg"
                />
              </button>
              <img
                loading="lazy"
                fetchpriority="low"
                class="absolute right-[3rem] top-[4.8rem] h-[2rem] w-[2rem] lg:hidden"
                src="/assets/images/landing/firstBlock/icons/scissors.svg"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      [ngClass]="
        secondLanding ? 'items-center space-x-[-11rem] lg:space-x-[-3rem]' : 'space-x-[-2rem] lg:space-x-[-0.6rem]'
      "
      class="z-[11] !mb-[-9rem] flex justify-center lg:!mb-[-2rem]"
    >
      <div
        [ngClass]="{ 'lg:h-[21.9rem] lg:w-[14.6rem]': secondLanding }"
        class="relative flex items-start justify-center"
        loading="lazy"
        fetchpriority="low"
      >
        <img
          [ngClass]="secondLanding ? 'h-[69.6rem] lg:absolute lg:top-0 lg:w-[14.6rem]' : 'h-[57.6rem]'"
          class="lg:border-box lg:h-auto lg:w-full"
          loading="lazy"
          fetchpriority="low"
          src="/assets/images/{{ secondLanding ? 'landing2' : 'landing' }}/firstBlock/eventsOrder/{{
            secondLanding ? 'battleSkins' : 'skins'
          }}.webp"
        />
        <span
          [ngClass]="
            secondLanding
              ? 'top-[17rem] lg:top-[5.5rem] lg:text-[1.1rem] lg:leading-[1.2rem]'
              : 'top-[4.5rem] lg:top-[1.2rem] lg:text-[1.3rem] lg:leading-[1.6rem]'
          "
          class="absolute max-w-[14.6rem] text-center text-[3.2rem] font-450 uppercase leading-[3.2rem] text-white lg:max-w-[6rem]"
        >
          @if (secondLanding) {
            {{ battleSkinstText }}
          } @else {
            {{ skinsText }}
          }
        </span>
      </div>
      <div
        [ngClass]="{ 'lg:h-[21.9rem] lg:w-[14.6rem]': secondLanding }"
        class="relative flex items-start justify-center"
        loading="lazy"
        fetchpriority="low"
      >
        <img
          [ngClass]="secondLanding ? 'h-[76.8rem] lg:absolute lg:top-0 lg:w-[14.6rem]' : 'h-[72.7rem]'"
          loading="lazy"
          fetchpriority="low"
          class="lg:border-box lg:h-auto lg:w-full"
          src="/assets/images/{{ secondLanding ? 'landing2' : 'landing' }}/firstBlock/eventsOrder/{{
            secondLanding ? 'skins' : 'battleEvent'
          }}.webp"
        />
        <span
          [ngClass]="
            secondLanding
              ? 'top-[19rem] lg:top-[5.5rem] lg:text-[1.1rem] lg:leading-[1.2rem]'
              : 'top-[4.5rem] lg:top-[1.2rem] lg:text-[1.3rem] lg:leading-[1.6rem]'
          "
          class="absolute max-w-[12.9rem] text-center text-[3.2rem] font-450 uppercase leading-[3.2rem] text-white lg:max-w-[6rem]"
        >
          @if (secondLanding) {
            {{ skinsText }}
          } @else {
            {{ battleEventText }}
          }
        </span>
      </div>
      <div
        [ngClass]="{ 'lg:h-[21.9rem] lg:w-[14.6rem]': secondLanding }"
        class="relative flex items-start justify-center"
        loading="lazy"
        fetchpriority="low"
      >
        <img
          [ngClass]="secondLanding ? 'h-[69.6rem] lg:absolute lg:top-0 lg:w-[14.6rem]' : 'h-[68.2rem]'"
          loading="lazy"
          fetchpriority="low"
          class="lg:border-box lg:h-auto lg:w-full"
          src="/assets/images/{{ secondLanding ? 'landing2' : 'landing' }}/firstBlock/eventsOrder/{{
            secondLanding ? 'battleEvent' : 'battleSkins'
          }}.webp"
        />
        <span
          [ngClass]="
            secondLanding
              ? 'top-[17rem] lg:top-[5.5rem] lg:text-[1.1rem] lg:leading-[1.2rem]'
              : 'top-[4.5rem] lg:top-[1.2rem] lg:text-[1.3rem] lg:leading-[1.6rem]'
          "
          class="absolute max-w-[14.6rem] text-center text-[3.2rem] font-450 uppercase leading-[3.2rem] text-white lg:max-w-[6rem]"
        >
          @if (secondLanding) {
            {{ battleEventText }}
          } @else {
            {{ battleSkinstText }}
          }
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #secondBlock>
  <div class="relative flex h-[88.8rem] items-center justify-end pt-[-7rem] lg:h-[21.6rem]">
    <img
      fetchpriority="low"
      class="absolute bottom-0 left-[-31.3rem] z-[1] h-full max-w-fit lg:left-[-10.25rem]"
      src="/assets/images/landing/secondBlock/topboard.webp"
    />
    <div
      class="z-[1] mr-[5.1rem] flex max-w-[32.3rem] flex-col space-y-[2.2rem] lg:mr-[0.1rem] lg:max-w-[18.7rem] lg:space-y-[1.2rem]"
    >
      <span
        i18n="@@landing.topboard.title"
        class="text-[4.4rem] font-450 leading-[5.8rem] text-white lg:text-[2.2rem] lg:leading-[2.6rem]"
        >ТОПОВЫЕ ПРИЗЫ</span
      >
      <span
        i18n="@@landing.topboard.desc"
        class="text-[1.6rem] font-325 leading-[2.4rem] text-[rgba(255,255,255,0.70)] lg:text-[1.2rem] lg:leading-[1.6rem]"
        >Участвуйте в ежедневных розыгрышах на сайте и наших соц. сетях, чтобы получить призы в виде редких предметов
        для CS2!</span
      >
    </div>
  </div>
</ng-template>

<ng-template #thirdBlock>
  <div class="relative flex h-[90.1rem] w-full items-center justify-center bg-[#0D0D39] lg:h-[21.2rem]">
    <div
      class="relative flex h-full w-full max-w-[117.2rem] items-center justify-start lg:max-w-[60rem] lg:px-[3.2rem]"
    >
      <div class="z-[1] flex max-w-[36.8rem] flex-col space-y-[2.2rem] lg:max-w-[18.4rem] lg:space-y-[1.2rem]">
        <span
          i18n="@@landing.dailyprizes.title"
          class="text-[4.4rem] font-450 leading-[5.8rem] text-white lg:text-[2.2rem] lg:leading-[2.6rem]"
          >БОНУСЫ И ПРИЗЫ</span
        >
        <span
          i18n="@@landing.dailyprizes.desc"
          class="text-[1.6rem] font-325 leading-[2.6rem] text-[rgba(255,255,255,0.70)] lg:text-[1.2rem] lg:leading-[1.6rem]"
          >Стремитесь к вершине каждый день, неделю и месяц, чтобы получить лучшие скины для CS2!</span
        >
      </div>
      <img
        fetchpriority="low"
        class="absolute right-[-17rem] top-0 z-[0] h-full lg:right-[-7.5rem]"
        src="/assets/images/landing/thirdBlock/dailyPrices.webp"
      />
    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="relative flex h-[56.2rem] w-full items-center justify-center lg:h-[23.7rem] lg:px-[1.6rem]">
    <div
      class="flex h-full w-full flex-col justify-between pb-[5.6rem] pt-[26.4rem] lg:flex-col-reverse lg:pt-[2.36rem]"
    >
      <div
        class="z-[1] flex space-x-[1.4rem] lg:flex-1 lg:flex-col lg:items-start lg:justify-center lg:space-x-0 lg:space-y-[1rem]"
      >
        <ng-container *ngTemplateOutlet="footerLoginButtons"></ng-container>
      </div>
      <div class="flex flex-col space-y-[1.6rem]">
        <div class="flex flex-col text-left lg:hidden">
          <div class="text-[1.4rem] font-400 leading-[2.2rem] text-[#A4AECB]">
            &copy; 2018 &#8211; {{ currentYear }} CSFail
          </div>

          <div class="w-[35rem] text-[1.2rem] font-325 leading-[2rem] text-[#7F8BAD]">
            @if (isRuLanguage) {
              AG AUTOMOTIVE LOGISTICS AND MANAGEMENT PTE. LTD.: Company number 202350466K, 68 CIRCULAR ROAD #02-01
              SINGAPORE (049422)
            } @else {
              ITSFAIL LTD: Company number 13246765, 16 John Nicholas Crescent, Ellesmere Port, Cheshire, United Kingdom,
              CH65 2DL
            }
          </div>
        </div>
      </div>
    </div>
    <div class="absolute right-[-3rem] h-full w-[70rem] lg:w-[30rem]">
      <img
        loading="lazy"
        fetchpriority="low"
        class="absolute bottom-0 right-0 h-[56.8rem] w-full lg:h-[26rem]"
        src="/assets/images/landing/footer/message.webp"
      />
      <span
        i18n="@@landing.footer.ak47"
        class="absolute right-[24rem] top-[47%] z-[1] max-w-[15rem] text-center text-[1.8rem] font-350 leading-[2.2rem] lg:right-[29%] lg:top-[40%] lg:max-w-[9.2rem] lg:text-[1.2rem] lg:leading-[1.6rem]"
        >Поднял AK-47 Императрицу На CSFAIL</span
      >
    </div>
  </div>
</ng-template>

<ng-template #loginButtons>
  @if (!authState.user()) {
    <ui-login-button
      classList="!flex !flex-row-reverse !h-[5.8rem] !pr-[2.2rem] !pl-[1.8rem] items-center justify-center space-x-reverse overflow-hidden !text-[1.5rem] !rounded-[1.8rem] bg-[linear-gradient(180deg,#2E3EA7_0%,#4050B7_100%)] text-left custom-transition-bg before:bg-[linear-gradient(180deg,#3446BC_0%,#495BCF_100%)] lg:!text-[1.2rem] lg:!h-[4.2rem] lg:!pr-[1rem] lg:!pl-[1rem] lg:!rounded-[1.2rem] lg:w-fit lg:rounded-[1.2rem] lg:px-[1rem]"
      [title]="signInText"
      icon="icon icon_lock-bold-2 !text-[2.8rem] mr-[0.2rem] lg:!text-[1.8rem] lg:mr-0"
      [redirectToMain]="true"
    />
  } @else if (secondLanding && authState.user()) {
    <a
      routerLink="/"
      class="!flex !h-[5.8rem] items-center justify-center space-x-[0.8rem] overflow-hidden !rounded-[1.8rem] bg-[linear-gradient(180deg,#2E3EA7_0%,#4050B7_100%)] !pl-[1.8rem] !pr-[2.2rem] text-left !text-[1.5rem] custom-transition-bg before:bg-[linear-gradient(180deg,#3446BC_0%,#495BCF_100%)] lg:!h-[4.2rem] lg:w-fit lg:!rounded-[1.2rem] lg:rounded-[1.2rem] lg:px-[1rem] lg:!pl-[1rem] lg:!pr-[1rem] lg:!text-[1.2rem]"
    >
      <i class="icon icon_lock-bold-2 mr-[0.2rem] !text-[2.8rem] lg:mr-0 lg:!text-[1.8rem]"></i>
      <span class="text-[1.5rem] font-400 leading-[2.2rem] text-white">{{ signInText }}</span>
    </a>
  }
</ng-template>

<ng-template #footerLoginButtons>
  @if (!authState.user()) {
    <ui-login-button
      classList="!flex !flex-row-reverse !h-[5.8rem] !pr-[2.2rem] !pl-[1.8rem] items-center justify-center space-x-reverse overflow-hidden !text-[1.5rem] !rounded-[1.8rem] bg-[linear-gradient(180deg,#2E3EA7_0%,#4050B7_100%)] text-left custom-transition-bg before:bg-[linear-gradient(180deg,#3446BC_0%,#495BCF_100%)] lg:!text-[1rem] lg:!h-[3.8rem] lg:!pr-[1rem] lg:!pl-[1rem] lg:!rounded-[1.2rem] lg:rounded-[1.2rem] lg:px-[1rem]"
      [title]="signInText"
      icon="icon icon_lock-bold-2 !text-[2.8rem] mr-[0.2rem] lg:hidden lg:mr-0"
      [redirectToMain]="true"
    />
  } @else if (secondLanding && authState.user()) {
    <a
      routerLink="/"
      class="!flex !h-[5.8rem] items-center justify-center space-x-[0.8rem] overflow-hidden !rounded-[1.8rem] bg-[linear-gradient(180deg,#2E3EA7_0%,#4050B7_100%)] !pl-[1.8rem] !pr-[2.2rem] text-left custom-transition-bg before:bg-[linear-gradient(180deg,#3446BC_0%,#495BCF_100%)] lg:!h-[3.8rem] lg:w-fit lg:!rounded-[1.2rem] lg:rounded-[1.2rem] lg:px-[1rem] lg:!pl-[1rem] lg:!pr-[1rem] lg:space-x-0"
    >
      <i class="icon icon_lock-bold-2 mr-[0.2rem] !text-[2.8rem] lg:mr-0 lg:hidden"></i>
      <span class="text-[1.5rem] font-400 leading-[2.2rem] text-white lg:text-[1rem]">{{ signInText }}</span>
    </a>
  }
</ng-template>